import { ca } from '@cian/analytics';
import { getCustomUrl, getTrackingProducts } from '../../utils/tracking';

export const trackClickHouseCard = (builderId: number, houseId: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardCountryBuilder',
    action: 'Click',
    label: 'HouseBuiltProjects',
    products: getTrackingProducts(builderId, { house_id: houseId }),
  });
};

export const trackClickPhoneButton = (builderId: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: 'Open_card_builder_contact_block_built',
    label: getCustomUrl(builderId),
    products: getTrackingProducts(builderId),
  });
};
